(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
if (!customElements.get('main-cart')) {
  customElements.define('main-cart', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      this.quantityTimers = new Map();
      this.noteTimer = null;
      this.reassuranceTimer = null;
      this.reassuranceIndex = 0;
      this.busy = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setAttribute('data-enhanced', '');
      this.addEventListener('click', event => this.onClick(event), { signal: this.signal });
      this.addEventListener('change', event => this.onChange(event), { signal: this.signal });
      this.addEventListener('submit', event => this.onSubmit(event), { capture: true, signal: this.signal });
      this.startReassurance();

      if (!window.__themeCartInitialGiftSyncComplete) {
        window.__themeCartInitialGiftSyncComplete = true;
        this.syncThresholdGifts().then(changed => {
          if (changed) return this.refresh(this.captureState());
        }).catch(() => {});
      }
    }

    get rootRoute() {
      const root = window.Shopify?.routes?.root || '/';
      return root.endsWith('/') ? root : `${root}/`;
    }

    route(path) {
      return `${this.rootRoute}${path}`.replace(/([^:]\/)\/+/g, '$1');
    }

    get sectionIds() {
      return [this.dataset.mainCartSectionId, document.querySelector('cart-drawer') ? 'cart-drawer' : null].filter(Boolean);
    }

    withSections(payload = {}) {
      return {
        ...payload,
        sections: this.sectionIds,
        sections_url: this.route('cart')
      };
    }

    async request(path, options = {}) {
      const { headers = {}, ...requestOptions } = options;
      const response = await fetch(this.route(path), {
        credentials: 'same-origin',
        ...requestOptions,
        headers: { Accept: 'application/json', ...headers }
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || this.dataset.errorMessage || 'Cart update failed.');
      return data;
    }

    getCart() {
      return this.request('cart.js');
    }

    onClick(event) {
      const reassuranceDot = event.target.closest('[data-main-cart-reassurance] [data-slider-dot]');
      if (reassuranceDot) {
        event.preventDefault();
        this.goToReassurance(Number(reassuranceDot.dataset.slideIndex));
        this.startReassurance(false);
        return;
      }

      const summary = event.target.closest('[data-main-cart-gift-summary]');
      if (summary) {
        event.preventDefault();
        this.toggleGiftWrap(summary.closest('details'));
        return;
      }

      const remove = event.target.closest('[data-main-cart-remove]');
      if (remove) {
        event.preventDefault();
        const line = remove.closest('[data-main-cart-line-key]');
        this.changeLine(line?.dataset.mainCartLineKey, 0, remove);
        return;
      }

      const thresholdGiftRemove = event.target.closest('[data-main-cart-threshold-gift-remove]');
      if (thresholdGiftRemove) {
        event.preventDefault();
        this.dismissThresholdGift(thresholdGiftRemove);
        return;
      }

      const thresholdGiftRestore = event.target.closest('[data-main-cart-threshold-gift-restore]');
      if (thresholdGiftRestore) {
        event.preventDefault();
        this.restoreThresholdGift(thresholdGiftRestore);
        return;
      }

      const giftAdd = event.target.closest('[data-main-cart-gift-add]');
      if (giftAdd) {
        event.preventDefault();
        this.addGiftWrap(giftAdd);
        return;
      }

      const giftRemove = event.target.closest('[data-main-cart-gift-remove]');
      if (giftRemove) {
        event.preventDefault();
        this.changeLine(giftRemove.dataset.lineKey, 0, giftRemove);
        return;
      }

    }

    onChange(event) {
      const quantity = event.target.closest('[data-main-cart-line-key] .quantity-selector__input');
      if (quantity) {
        const line = quantity.closest('[data-main-cart-line-key]');
        const key = line?.dataset.mainCartLineKey;
        window.clearTimeout(this.quantityTimers.get(key));
        this.quantityTimers.set(key, window.setTimeout(() => {
          this.changeLine(key, Math.max(0, Number(quantity.value) || 0), quantity);
        }, 220));
        return;
      }

      const note = event.target.closest('[data-main-cart-note]');
      if (note) {
        window.clearTimeout(this.noteTimer);
        this.noteTimer = window.setTimeout(() => this.saveNote(note.value), 450);
      }
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (form.closest('[data-main-cart-cross-sells], cart-personality') && (form.getAttribute('action') || '').includes('/cart/add')) {
        event.preventDefault();
        event.stopPropagation();
        this.addCrossSell(form, event.submitter);
        return;
      }

      if (form.classList.contains('main-cart__form') && event.submitter?.name === 'update') {
        event.preventDefault();
        this.updateAll(event.submitter);
      }
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
    }

    setButtonBusy(button, busy) {
      if (!button) return;
      button.toggleAttribute('disabled', busy);
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    async mutate(operation, trigger, errorTarget = null) {
      if (this.busy) return;
      const state = this.captureState();
      this.setBusy(true);
      this.setButtonBusy(trigger, true);
      this.hideErrors();
      try {
        const mutationResult = await operation();
        const giftsChanged = await this.syncThresholdGifts();
        const cart = await this.getCart();
        this.updateHeaderCount(cart.item_count);
        const rendered = !giftsChanged && await this.renderSections(mutationResult?.sections, state);
        if (!rendered) await this.refresh(state);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        this.showError(errorTarget || trigger?.closest('[data-main-cart-line-key]')?.querySelector('[data-main-cart-line-error]'), error.message);
      } finally {
        this.setButtonBusy(trigger, false);
        this.setBusy(false);
      }
    }

    changeLine(key, quantity, trigger) {
      if (!key) return;
      this.mutate(() => this.request('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.withSections({ id: key, quantity }))
      }), trigger);
    }

    getDismissedGiftTiers(cart) {
      return new Set(String(cart?.attributes?.gift_declined_tiers__ || '').split(',').map(tier => tier.trim()).filter(Boolean));
    }

    giftDismissalAttributes(tiers) {
      return { gift_declined_tiers__: [...tiers].sort((a, b) => Number(a) - Number(b)).join(',') };
    }

    dismissThresholdGift(button) {
      const key = button.dataset.lineKey;
      const tier = button.dataset.giftTier;
      if (!key || !tier) return;
      this.mutate(async () => {
        const cart = await this.getCart();
        const dismissedTiers = this.getDismissedGiftTiers(cart);
        dismissedTiers.add(tier);
        return this.request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.withSections({
            updates: { [key]: 0 },
            attributes: this.giftDismissalAttributes(dismissedTiers)
          }))
        });
      }, button);
    }

    restoreThresholdGift(button) {
      const tier = button.dataset.giftTier;
      const variantId = Number(button.dataset.variantId);
      if (!tier || !variantId) return;
      this.mutate(async () => {
        const cart = await this.getCart();
        const dismissedTiers = this.getDismissedGiftTiers(cart);
        dismissedTiers.delete(tier);
        await this.request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: this.giftDismissalAttributes(dismissedTiers) })
        });
        return this.request('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.withSections({
            items: [{ id: variantId, quantity: 1, properties: { _cart_gift_tier: tier } }]
          }))
        });
      }, button, button.closest('.cart-dismissed-gift')?.querySelector('[role="alert"]'));
    }

    addGiftWrap(button) {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      this.mutate(() => this.request('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.withSections({ items: [{ id: variantId, quantity: 1, properties: { _cart_gift_wrap: 'true' } }] }))
      }), button);
    }

    addCrossSell(form, submitter) {
      if (form.dataset.cartSubmitting === 'true') return;
      form.dataset.cartSubmitting = 'true';
      const data = new FormData(form);
      if (!data.get('quantity')) data.set('quantity', '1');
      data.set('sections', this.sectionIds.join(','));
      data.set('sections_url', this.route('cart'));
      this.mutate(() => this.request('cart/add.js', { method: 'POST', body: data }), submitter, form.querySelector('[role="alert"]'))
        .finally(() => { delete form.dataset.cartSubmitting; });
    }

    updateAll(button) {
      const updates = {};
      this.querySelectorAll('[data-main-cart-line-key] .quantity-selector__input').forEach(input => {
        const key = input.closest('[data-main-cart-line-key]')?.dataset.mainCartLineKey;
        if (key) updates[key] = Math.max(0, Number(input.value) || 0);
      });
      const note = this.querySelector('[data-main-cart-note]')?.value;
      this.mutate(() => this.request('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.withSections({ updates, note }))
      }), button);
    }

    async saveNote(note) {
      try {
        const cart = await this.request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note })
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        this.showError(this.querySelector('[data-main-cart-error]'), error.message);
      }
    }

    async syncThresholdGifts() {
      const configNode = this.querySelector('[data-main-cart-gift-rules]');
      if (!configNode) return false;
      let rules = [];
      try { rules = JSON.parse(configNode.textContent).rules || []; }
      catch { return false; }

      const previousSync = window.__themeCartGiftSyncPromise || Promise.resolve();
      const currentSync = previousSync
        .catch(() => false)
        .then(() => this.reconcileThresholdGifts(rules));
      window.__themeCartGiftSyncPromise = currentSync;
      try {
        return await currentSync;
      } finally {
        if (window.__themeCartGiftSyncPromise === currentSync) window.__themeCartGiftSyncPromise = null;
      }
    }

    async reconcileThresholdGifts(rules) {
      let changed = false;
      const cart = await this.getCart();
      const giftItems = cart.items.filter(item => item.properties?._cart_gift_tier);
      const qualifyingTotal = cart.items.reduce((total, item) => {
        if (item.properties?._cart_gift_tier || item.properties?._cart_gift_wrap === 'true') return total;
        return total + item.final_line_price;
      }, 0);
      const rulesByTier = new Map(
        rules
          .filter(rule => rule.tier && Number(rule.variantId) > 0 && Number(rule.threshold) > 0)
          .map(rule => [String(rule.tier), rule])
      );
      const dismissedTiers = this.getDismissedGiftTiers(cart);
      const eligibleDismissedTiers = new Set(
        [...dismissedTiers].filter(tier => {
          const rule = rulesByTier.get(tier);
          return rule && qualifyingTotal >= Number(rule.threshold);
        })
      );
      if (eligibleDismissedTiers.size !== dismissedTiers.size) {
        await this.request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: this.giftDismissalAttributes(eligibleDismissedTiers) })
        });
        changed = true;
      }
      const retainedTiers = new Set();

      for (const gift of giftItems) {
        const tier = String(gift.properties._cart_gift_tier);
        const rule = rulesByTier.get(tier);
        const eligible = Boolean(rule && qualifyingTotal >= Number(rule.threshold) && !eligibleDismissedTiers.has(tier));
        const correctVariant = Boolean(rule && Number(gift.variant_id) === Number(rule.variantId));
        const duplicate = retainedTiers.has(tier);

        if (!eligible || !correctVariant || duplicate) {
          await this.request('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0 })
          });
          changed = true;
          continue;
        }

        retainedTiers.add(tier);
        if (gift.quantity !== 1) {
          await this.request('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 1 })
          });
          changed = true;
        }
      }

      for (const [tier, rule] of rulesByTier) {
        if (qualifyingTotal < Number(rule.threshold) || retainedTiers.has(tier) || eligibleDismissedTiers.has(tier)) continue;
        await this.request('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(rule.variantId), quantity: 1, properties: { _cart_gift_tier: tier } }] })
        });
        changed = true;
      }

      return changed;
    }

    async refresh(state) {
      const sectionId = this.dataset.mainCartSectionId;
      const url = new URL(this.route('cart'), window.location.origin);
      url.searchParams.set('sections', `${sectionId},cart-drawer`);
      url.searchParams.set('_main_cart', Date.now().toString());
      const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(this.dataset.errorMessage);
      const sections = await response.json();
      const rendered = await this.renderSections(sections, state);
      if (!rendered) throw new Error(this.dataset.errorMessage);
    }

    async renderSections(sections, state) {
      if (!sections) return false;
      const sectionId = this.dataset.mainCartSectionId;
      const html = sections[sectionId];
      if (!html) return false;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextCart = parsed.querySelector('main-cart');
      const nextContent = nextCart?.querySelector('[data-main-cart-content]');
      const currentContent = this.querySelector('[data-main-cart-content]');
      if (!nextCart || !nextContent || !currentContent) return false;

      const currentRules = this.querySelector('[data-main-cart-gift-rules]');
      const nextRules = nextCart.querySelector('[data-main-cart-gift-rules]');
      if (currentRules && nextRules) currentRules.textContent = nextRules.textContent;
      this.dataset.errorMessage = nextCart.dataset.errorMessage;
      this.dataset.discountError = nextCart.dataset.discountError;
      currentContent.replaceChildren(...Array.from(nextContent.children));
      this.animateState(state);
      this.startReassurance();

      const drawer = document.querySelector('cart-drawer');
      if (drawer && sections['cart-drawer']) {
        try {
          await drawer.renderSection?.(sections['cart-drawer'], Boolean(drawer.dialog?.open), drawer.returnFocus);
        } catch {}
      }
      return true;
    }

    captureState() {
      const rootRect = this.getBoundingClientRect();
      const activeElement = document.activeElement;
      const activeLine = activeElement?.closest?.('[data-main-cart-line-key]');
      const items = new Map();
      this.querySelectorAll('[data-main-cart-line-key]').forEach((element, index) => {
        items.set(element.dataset.mainCartLineKey, {
          clone: element.cloneNode(true),
          index,
          rect: element.getBoundingClientRect(),
          signature: element.textContent.replace(/\s+/g, ' ').trim()
        });
      });
      return {
        activeControl: activeElement?.matches?.('.quantity-selector__input') ? 'quantity' : activeElement?.matches?.('[data-main-cart-remove]') ? 'remove' : null,
        activeLineKey: activeLine?.dataset.mainCartLineKey || null,
        giftOpen: Boolean(this.querySelector('.main-cart__gift-wrap')?.open),
        items,
        progress: this.querySelector('.cart-rewards__bar')?.style.getPropertyValue('--cart-progress') || '0%',
        rootRect
      };
    }

    animateState(state) {
      if (!state) return;
      const giftWrap = this.querySelector('.main-cart__gift-wrap');
      if (giftWrap && state.giftOpen) giftWrap.open = true;

      const currentItems = new Map();
      this.querySelectorAll('[data-main-cart-line-key]').forEach(element => currentItems.set(element.dataset.mainCartLineKey, element));

      currentItems.forEach((element, key) => {
        const previous = state.items.get(key);
        if (!previous) {
          if (!this.reducedMotion) element.animate([
            { opacity: 0, transform: 'translate3d(0, 12px, 0)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0)' }
          ], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' });
          return;
        }
        if (this.reducedMotion) return;
        const rect = element.getBoundingClientRect();
        const deltaX = previous.rect.left - rect.left;
        const deltaY = previous.rect.top - rect.top;
        const changed = previous.signature !== element.textContent.replace(/\s+/g, ' ').trim();
        if (Math.abs(deltaX) < .5 && Math.abs(deltaY) < .5 && !changed) return;
        element.animate([
          { opacity: changed ? .68 : 1, transform: `translate3d(${deltaX}px, ${deltaY}px, 0)` },
          { opacity: 1, transform: 'translate3d(0, 0, 0)' }
        ], { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      });

      state.items.forEach((previous, key) => {
        if (currentItems.has(key)) return;
        const clone = previous.clone;
        clone.removeAttribute('data-main-cart-line-key');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        Object.assign(clone.style, {
          background: 'var(--color-background)',
          height: `${previous.rect.height}px`,
          left: `${previous.rect.left - state.rootRect.left}px`,
          margin: '0',
          pointerEvents: 'none',
          position: 'absolute',
          top: `${previous.rect.top - state.rootRect.top}px`,
          width: `${previous.rect.width}px`,
          zIndex: '3'
        });
        this.append(clone);
        if (this.reducedMotion) {
          clone.remove();
          return;
        }
        clone.animate([
          { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' },
          { opacity: 0, transform: 'translate3d(0, -8px, 0) scale(.985)' }
        ], { duration: 180, easing: 'cubic-bezier(.4, 0, 1, 1)' }).finished.then(() => clone.remove()).catch(() => clone.remove());
      });

      const progressBar = this.querySelector('.cart-rewards__bar');
      if (progressBar && !this.reducedMotion) {
        const nextProgress = progressBar.style.getPropertyValue('--cart-progress');
        if (state.progress !== nextProgress) progressBar.animate([
          { width: state.progress },
          { width: nextProgress }
        ], { duration: 380, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      }

      const empty = this.querySelector('.main-cart__empty');
      if (empty && state.items.size && !this.reducedMotion) empty.animate([
        { opacity: 0, transform: 'translate3d(0, 8px, 0)' },
        { opacity: 1, transform: 'translate3d(0, 0, 0)' }
      ], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' });

      this.restoreFocus(state);
    }

    restoreFocus(state) {
      if (!state.activeLineKey) return;
      const line = Array.from(this.querySelectorAll('[data-main-cart-line-key]')).find(element => element.dataset.mainCartLineKey === state.activeLineKey);
      let target = null;
      if (state.activeControl === 'quantity') target = line?.querySelector('.quantity-selector__input');
      else if (state.activeControl === 'remove') target = line?.querySelector('[data-main-cart-remove]');
      target?.focus?.({ preventScroll: true });
    }

    toggleGiftWrap(details) {
      if (!details) return;
      const panel = details.querySelector('[data-main-cart-gift-panel]');
      const summary = details.querySelector('[data-main-cart-gift-summary]');
      if (!panel || !summary) return;
      panel.getAnimations().forEach(animation => animation.cancel());
      const opening = !details.open;
      if (opening) details.open = true;
      if (this.reducedMotion) {
        details.open = opening;
        return;
      }
      const height = panel.scrollHeight;
      const animation = panel.animate(opening ? [
        { height: '0px', opacity: 0, transform: 'translateY(-3px)' },
        { height: `${height}px`, opacity: 1, transform: 'translateY(0)' }
      ] : [
        { height: `${panel.getBoundingClientRect().height}px`, opacity: 1, transform: 'translateY(0)' },
        { height: '0px', opacity: 0, transform: 'translateY(-2px)' }
      ], {
        duration: opening ? 210 : 145,
        easing: opening ? 'cubic-bezier(.22, 1, .36, 1)' : 'cubic-bezier(.4, 0, 1, 1)'
      });
      animation.finished.then(() => {
        if (!opening) details.open = false;
      }).catch(() => {});
    }

    goToReassurance(index) {
      const reassurance = this.querySelector('[data-main-cart-reassurance]');
      const track = reassurance?.querySelector('[data-main-cart-reassurance-track]');
      const slides = track?.children;
      const dots = reassurance?.querySelectorAll('[data-slider-dot]');
      if (!track || !slides?.length) return;
      this.reassuranceIndex = (index + slides.length) % slides.length;
      const slideHeight = slides[0].getBoundingClientRect().height;
      track.style.transform = `translateY(-${this.reassuranceIndex * slideHeight}px)`;
      dots?.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === this.reassuranceIndex ? 'true' : 'false'));
    }

    startReassurance(reset = true) {
      this.stopReassurance();
      const reassurance = this.querySelector('[data-main-cart-reassurance]');
      const track = reassurance?.querySelector('[data-main-cart-reassurance-track]');
      const slides = track?.children;
      if (!track || !slides || slides.length < 2) return;
      if (reset) this.reassuranceIndex = 0;
      this.goToReassurance(this.reassuranceIndex);
      if (this.reducedMotion) return;
      this.reassuranceTimer = window.setInterval(() => {
        this.goToReassurance(this.reassuranceIndex + 1);
      }, 3600);
    }

    stopReassurance() {
      window.clearInterval(this.reassuranceTimer);
      this.reassuranceTimer = null;
    }

    updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = count; });
      document.querySelectorAll('[data-cart-text-template]').forEach(element => {
        element.textContent = element.dataset.cartTextTemplate.replace('__COUNT__', count);
      });
      document.querySelectorAll('[data-cart-count-link]').forEach(element => {
        if (element.dataset.cartLabelTemplate) element.setAttribute('aria-label', element.dataset.cartLabelTemplate.replace('__COUNT__', count));
      });
    }

    hideErrors() {
      this.querySelectorAll('[data-main-cart-line-error], [data-main-cart-error]').forEach(element => { element.hidden = true; });
    }

    showError(target, message) {
      const errorTarget = target || this.querySelector('[data-main-cart-error]');
      if (!errorTarget) return;
      errorTarget.textContent = message;
      errorTarget.hidden = false;
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.quantityTimers?.forEach(timer => window.clearTimeout(timer));
      window.clearTimeout(this.noteTimer);
      this.stopReassurance();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
